// extracted by mini-css-extract-plugin
export default {"root":"IPSgCR","iframe":"oAQm6m","hidden":"iMp6tt"};